import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Box, Button, Container, Group, Stack, Text, Title } from '@mantine/core';
import { ROUTES } from '@/routes/paths';

// Завершающий призыв: говорит, что нужно для старта, чтобы регистрация не была неожиданностью.
export default function FinalCta() {
  const { t } = useTranslation();

  return (
    <Box bg="lime.0">
      <Container size="lg" py={{ base: 'xl', md: 56 }}>
        <Group justify="space-between" gap="lg">
          <Stack gap={4} style={{ flex: '1 1 320px' }}>
            <Title order={2} fz={{ base: 22, sm: 30 }}>
              {t('landing.final.title')}
            </Title>
            <Text c="gray.8">{t('landing.final.text')}</Text>
          </Stack>
          <Button component={Link} to={ROUTES.REGISTER}>
            {t('landing.services.cta')}
          </Button>
        </Group>
      </Container>
    </Box>
  );
}
